import type { IconData } from '@stacksjs/iconify-core'

export const interfaceEssentialSettingsToggleHorizontal: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M30.48 20.57H32v7.62h-1.52Zm0-18.29h-1.53V.76H3.05v1.52H1.53v1.53H0v7.62h1.53v1.52h1.52v1.52h25.9v-1.52h1.53v-1.52H32V3.81h-1.52ZM12.19 9.9h-1.52v1.53H9.15v1.52H4.57v-1.52H3.05V9.9H1.53V5.33h1.52V3.81h1.52V2.28h4.58v1.53h1.52v1.52h1.52Zm16.76 18.29h1.53v1.52h-1.53Zm0-9.15h1.53v1.53h-1.53Zm-1.52 3.05h1.52v3.05h-1.52Zm-6.09 7.62v-1.52h-1.53v1.52H3.05v1.53h25.9v-1.53zm4.57-9.14h1.52v1.52h-1.52Zm-7.62 0h1.52v7.62h-1.52Z\"/><path fill=\"currentColor\" d=\"M9.15 5.33h1.52v3.05H9.15ZM7.62 3.81h1.53v1.52H7.62Zm12.19 15.23v1.53h1.53v-1.53h7.61v-1.52H3.05v1.52zM1.53 28.19h1.52v1.52H1.53Zm0-9.15h1.52v1.53H1.53ZM0 20.57h1.53v7.62H0Z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default interfaceEssentialSettingsToggleHorizontal
